import { Injectable } from '@angular/core';
import {GroupConfig, GroupConfigs} from '../../shared/models/config';

@Injectable({
  providedIn: 'root'
})
export class GetConfigReportService {

  constructor() {
  }
  getConfigReportWithRangeDate(): GroupConfig {
    return {
      'config': [
        {
          type: 'dateRangePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['startDate' , 'endDate'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        ]
    }
  }
  getConfigReportNewChurnWithRangeDate(): GroupConfig {
    return {
      'config': [
        {
          type: 'dateRangePicker',
          label: 'INVOICES_TRIGGER_PERIOD',
          controlName: ['startDate' , 'endDate'],
          placeholder: 'INVOICES_TRIGGER_PERIOD',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'multiselect',
          label: 'GENERIC_OFFICE_LABEL',
          controlName: ['office', 'id'],
          placeholder: 'GENERIC_OFFICE_LABEL',
          data: 'office',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }

  getConfigPilotPlayersFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_CLIENTS_NAME',
          controlName: ['clientName'],
          placeholder: 'GENERIC_CLIENTS',
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_SITE',
          controlName: ['siteName'],
          placeholder: 'GENERIC_SITE',
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PLAYER_NAME',
          controlName: ['playerName'],
          placeholder: 'GENERIC_PLAYER_NAME',
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_SALES_LABEL',
          controlName: ['salesName'],
          placeholder: 'GENERIC_SALES_LABEL',
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['serviceID', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: { value: 'id', vue: 'name' },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          data: 'product',
          options: { value: 'id', vue: 'name' },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['countryCode', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: { value: 'code', vue: 'name' },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'ORDERS_LIST_DELIVERY_DATE',
          controlName: ['deliveryDate'],
          placeholder: 'ORDERS_LIST_DELIVERY_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: false
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_UPDATED_LABEL',
          controlName: ['updated'],
          placeholder: 'GENERIC_UPDATED_LABEL',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: false
            }
          },
          presentation: 'filter'
        },
      ]
    }
  }

  getConfigPilotPlayersProlongation(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: 'textarea',
          controlName: ['comment'],
          placeholder: 'textarea',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        }]
    }
  }
  getSupportConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSupportFilter()
      ]
    }
  }
  getConfigSupportFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_NAME',
          controlName: ['lastName'],
          placeholder: 'ORDER_FORM_CONTACT_NAME',
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_SURNAME',
          controlName: ['firstName'],
          placeholder: 'ORDER_FORM_CONTACT_SURNAME',
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'REPORT_SUPPORT_LIST_VECTOR',
          controlName: ['vector'],
          placeholder: 'REPORT_SUPPORT_LIST_VECTOR',
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_FROM_DATE',
          controlName: ['fromDate'],
          placeholder: 'GENERIC_FROM_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: false
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_TO_DATE',
          controlName: ['toDate'],
          placeholder: 'GENERIC_TO_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: false
            }
          },
          presentation: 'filter'
        },
      ]
    }
  }
}
